/* ============================================
   TFS Wheels — Media Gallery Web Component
   Simple click-to-swap thumbnail gallery.
   ============================================ */

if (!customElements.get('media-gallery')) {
  class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.mainImage = null;
      this.thumbnails = [];
    }

    connectedCallback() {
      this.thumbnails = this.querySelectorAll('.pdp-thumb');
      if (this.thumbnails.length === 0) return;

      // Find the main image element
      const targetId = this.thumbnails[0]?.dataset.target;
      this.mainImage = targetId ? document.getElementById(targetId) : this.querySelector('.pdp-main-image img');

      this.thumbnails.forEach(thumb => {
        thumb.addEventListener('click', this.onThumbClick.bind(this));
      });
    }

    onThumbClick(e) {
      const thumb = e.currentTarget;
      const imgSrc = thumb.dataset.img;

      if (!imgSrc || !this.mainImage) return;

      // Update active state
      this.thumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      // Fade out, preload new image, then fade in
      this.mainImage.style.opacity = '0';

      setTimeout(() => {
        const url400 = imgSrc.replace(/width=\d+/, 'width=400');
        const url600 = imgSrc.replace(/width=\d+/, 'width=600');
        const newSrcset = `${url400} 400w, ${url600} 600w, ${imgSrc} 800w`;

        // Preload the new image before showing it
        const preload = new Image();
        preload.srcset = newSrcset;
        preload.sizes = this.mainImage.sizes || '(min-width: 1024px) 500px, (min-width: 768px) 60vw, 100vw';
        preload.src = imgSrc;

        const show = () => {
          this.mainImage.srcset = newSrcset;
          this.mainImage.src = imgSrc;
          this.mainImage.style.opacity = '1';
        };

        if (preload.complete) {
          show();
        } else {
          preload.onload = show;
          preload.onerror = show; // still swap on error
        }
      }, 150);
    }

    /* Public method: set active by media ID (used by variant switcher) */
    setActiveMedia(mediaId) {
      const thumb = this.querySelector(`.pdp-thumb[data-media-id="${mediaId}"]`);
      if (thumb && !thumb.classList.contains('active')) {
        thumb.click();
      }
    }
  }

  customElements.define('media-gallery', MediaGallery);
}
